module.exports = __webpack_public_path__ + "img/copy_inverted.fbc84f18.svg";